import { forwardRef, ReactNode } from 'react';
import { SxProps, Theme, useTheme } from '@mui/material/styles';
import { StyledLabel } from './styles';

interface LabelProps {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  variant?: 'filled' | 'outlined' | 'ghost' | 'soft';
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
}

const Label = forwardRef<HTMLSpanElement, LabelProps>(
  ({ children, color = 'default', variant = 'soft', sx, ...other }, ref) => {
    const theme = useTheme();

    return (
      <StyledLabel
        ownerState={{
          color: color,
          variant: variant!,
        }}
        ref={ref}
        component="span"
        color={color}
        sx={{
          ...sx,
        }}
        theme={theme}
        {...other}
      >
        {children}
      </StyledLabel>
    );
  },
);

export default Label;
